// import '../../util/polyfill';

export default function() {
	const body = document.getElementsByTagName('BODY')[0];
	const sectionmenu = document.querySelector('#sectionmenu');
	const allSections = document.querySelectorAll('.c-productdetail__section');
	const addedOffset = 205;

	function sectionMenu(sectionmenuOffset, scrollPosition, allSections, activeSection) {
		// recalc
		sectionmenuOffset = sectionmenu.offsetHeight;
		scrollPosition = document.documentElement.scrollTop - sectionmenuOffset + addedOffset;

		for (let i = 0; i < allSections.length; i++) {
			const sectionOffset = allSections[i].offsetTop;
			let sectionName = '' + allSections[i].id;
			let nextSectionOffset = null;

			if (i < allSections.length - 1) {
				nextSectionOffset = allSections[i + 1].offsetTop;
			}

			if (sectionName !== '') {
				sectionName = sectionName.replace('s-', '#');
				const sectionMenuItem = document.querySelector(sectionName);

				if (sectionMenuItem != null && sectionName !== activeSection) {
					if (nextSectionOffset != null && scrollPosition > nextSectionOffset) {
						// Wanneer je verder bent gescrollt dan 0, niets doen..
					} else {
						if (sectionOffset <= scrollPosition) {
							if (document.querySelector('.active-tab') != null) {
								document.querySelector('.active-tab').classList.remove('active-tab');
							}
							sectionMenuItem.classList.add('active-tab');
							activeSection = sectionName;
						}
					}
				}
			}
		}
	}

	if (sectionmenu != null && allSections != null && allSections.length > 0) {
		let sectionmenuOffset = 0;
		let scrollPosition = 0;
		let activeSection = '';

		sectionmenuOffset = sectionmenu.offsetHeight;
		scrollPosition = document.documentElement.scrollTop - sectionmenuOffset + addedOffset;

		if (document.querySelector('.active-tab') != null) {
			activeSection = document.querySelector('.active-tab').id;
		}

		sectionMenu(sectionmenuOffset, scrollPosition, allSections, activeSection);

		window.resize = () => {
			// sectionmenuOffset = sectionmenu.offsetHeight;
			sectionMenu(sectionmenuOffset, scrollPosition, allSections, activeSection);
		};

		window.onscroll = () => {
			// sectionmenuOffset = sectionmenu.offsetHeight;

			if (sectionmenu.getBoundingClientRect().top <= 0) {
				body.classList.add('sticky-sectionmenu');
			} else {
				body.classList.remove('sticky-sectionmenu');
			}

			sectionMenu(sectionmenuOffset, scrollPosition, allSections, activeSection);
		};
	}
}
